import { baseApi } from './baseApi';

const GalleryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getImages: builder.query({
      query: (queryParameters) => ({
        url: '/gallery/all',
        method: 'GET',
        params: queryParameters,
      }),
      providesTags: ['gallery'],
    }),
    getSingleImage: builder.query({
      query: (id: string) => ({
        url: `/gallery/${id}`,
        method: 'GET',
      }),
      providesTags: ['gallery'],
    }),
  }),
});

export const { useGetImagesQuery, useGetSingleImageQuery } = GalleryApi;
